export const translations = {
  en: {
    // Nav
    nav_home: "Home",
    nav_apartments: "Apartments",
    nav_facilities: "Facilities",
    nav_location: "Location",
    nav_gallery: "Gallery",
    nav_contact: "Contact",
    nav_book_now: "Book Now",
    brand_villas: "Villas",

    // Hero
    hero_eyebrow: "A peaceful Cretan escape",
    hero_h1_a: "Relaxing Villa",
    hero_h1_b: "Apartments",
    hero_h1_c: "in",
    hero_h1_d: "Istron, Crete",
    hero_sub:
      "Bright, airy apartments with sea, garden, and mountain views — just 900 m from Karavostasi Beach.",
    hero_cta_book: "Book Your Stay",
    hero_cta_explore: "Explore the Villas",
    hero_loc: "Istron · Crete",
    hero_h1_900m: "900 m from Karavostasi Beach",
    hero_h1_pool: "Outdoor swimming pool",
    hero_h1_wifi: "Free WiFi & parking",
    hero_h1_agios: "10 km from Agios Nikolaos",

    // About
    about_eyebrow: "— About the property",
    about_title_a: "Welcome to",
    about_title_b: "Athina",
    about_title_c: "Villas",
    about_text:
      "Athina Villas offers comfortable, family-friendly apartments in Istron, surrounded by Cretan countryside and blooming gardens. Three layouts — one or two bedrooms, with the option of a sea view — make it ideal for couples, families, and travelers seeking a peaceful, pet-friendly stay close to the beach.",
    about_stat1: "Couples rating",
    about_stat2: "To Karavostasi",
    about_stat3: "Agios Nikolaos",

    // Apartments
    apts_eyebrow: "— The apartments",
    apts_title_a: "Three layouts.",
    apts_title_b: "One",
    apts_title_c: "sun-soaked",
    apts_title_d: "garden.",
    apts_intro:
      "Each apartment is bright, airy and fully equipped — choose the layout that fits your group, then settle into slow Cretan days.",
    apts_most_popular: "Most popular",
    apts_guests_3: "Up to 3 guests",
    apts_guests_5: "Up to 5 guests",
    apts_type_1: "One-Bedroom Apartment",
    apts_type_2: "Two-Bedroom Apartment",
    apts_type_3: "Two-Bedroom Apartment · Sea View",
    apts_bed_full: "1 full bed",
    apts_bed_twin: "twin beds",
    apts_bed_sofa: "1 sofa bed",
    apts_bed_bedroom: "bedroom",
    apts_bed_bedroom_1: "bedroom 1",
    apts_bed_bedroom_2: "bedroom 2",
    apts_bed_living: "living room",
    apts_view_garden: "Garden & mountain views",
    apts_view_sea: "Cretan sea view",
    apts_view_label: "View",
    apts_price_label: "Price",
    apts_per_night: "per night",
    apts_cta: "Request this apartment",
    apts_pricing_note:
      "Indicative rates. Excludes €2/night environmental fee. Final prices confirmed on request.",
    apts_includes: "— Every apartment includes",
    apts_floor_ground: "Ground floor",
    apts_inc_ac: "Air-conditioning",
    apts_inc_kitchen: "Fully equipped kitchen",
    apts_inc_bath: "Private bathroom",
    apts_inc_balcony: "Private balcony",
    apts_inc_sofa: "Sofa bed",
    apts_inc_tv: "TV",
    apts_inc_entrance: "Private entrance",
    apts_inc_pool: "Pool access",

    // Facilities
    fac_eyebrow: "— Most popular facilities",
    fac_title_a: "Everything for an",
    fac_title_b: "unhurried",
    fac_title_c: "stay.",
    fac_pool: "Outdoor swimming pool",
    fac_sun: "Free sun loungers",
    fac_garden: "Garden",
    fac_bbq: "BBQ facilities",
    fac_kids: "Children's playground",
    fac_seating: "Outdoor seating area",
    fac_picnic: "Picnic area",
    fac_wifi: "Free WiFi",
    fac_parking: "Free parking",
    fac_nonsmoking: "Non-smoking rooms",

    // Location
    loc_eyebrow: "— Location",
    loc_title_a: "Discover Istron &",
    loc_title_b: "Agios Nikolaos",
    loc_intro:
      "Located in peaceful Istron, close to beaches, local taverns, cafés, shops, and the scenic seaside town of Agios Nikolaos.",
    loc_map_label: "Aerial · Istron, Crete",
    loc_map_caption: "Coastal Crete · GR",
    loc_address: "Αθηνά Βίλας Ιστρο, Kalo Chorio 721 00, Crete",
    loc_d_karavostasi: "Karavostasi Beach",
    loc_d_taverns: "Taverns, cafés & shops",
    loc_d_kalou: "Kalou Choriou Beach",
    loc_d_voulisma: "Voulisma Beach",
    loc_d_ammoudara: "Ammoudara Beach",
    loc_d_agios: "Agios Nikolaos",
    loc_d_lake: "Lake Voulismeni",
    loc_d_panagia: "Panagia Vrefotrofos",
    loc_d_airport: "Sitia Public Airport",
    loc_v_900m: "900 m",
    loc_v_10min: "10-min walk",
    loc_v_15min: "15-min walk",
    loc_v_4min: "4-min drive",
    loc_v_8km: "8 km",
    loc_v_10km: "10 km",
    loc_v_55km: "55 km",

    // Gallery
    gal_eyebrow: "— Gallery",
    gal_title_a: "Moments at",
    gal_title_b: "Athina",
    gal_intro:
      "A glimpse of the pool, gardens, apartments and the coast just down the road.",
    gal_pool: "Swimming pool",
    gal_pool_c: "Sunlit poolside",
    gal_apt: "Apartment",
    gal_apt_c: "Bright living space",
    gal_balcony: "Balcony view",
    gal_balcony_c: "Mountain stone terrace",
    gal_garden: "Garden",
    gal_garden_c: "Villa Athina · in the green",
    gal_interior: "Interior",
    gal_interior_c: "Arched living room",
    gal_twin: "Twin room",
    gal_twin_c: "Restful bedrooms",
    gal_twin_door_c: "Open to the terrace",
    gal_coast: "Coastline",
    gal_coast_c: "Olive hills meet the sea",

    // Reviews
    rev_eyebrow: "— Guest reviews",
    rev_wonderful: "Wonderful",
    rev_from: "From",
    rev_verified: "verified reviews on Booking.com",
    rev_cat_clean: "Cleanliness",
    rev_cat_value: "Value",
    rev_cat_host: "Host",
    rev_cat_loc: "Location",

    // Booking
    book_eyebrow: "— Reserve your stay",
    book_title_a: "Plan your stay at",
    book_title_b: "Athina Villas",
    book_intro:
      "Send us a booking request and we'll get back to you with availability, rates and any local recommendations for a peaceful Cretan escape near the beach.",
    book_checkin: "Check-in",
    book_checkout: "Check-out",
    book_phone_lbl: "Phone",
    book_email_lbl: "Email",
    book_address_lbl: "Address",
    book_f_name: "Full name",
    book_f_email: "Email",
    book_f_phone: "Phone",
    book_f_guests: "Guests",
    book_f_message: "Message",
    book_p_name: "Your full name",
    book_p_email: "you@example.com",
    book_p_phone: "+30 ...",
    book_p_checkin: "Select check-in",
    book_p_checkout: "Select check-out",
    book_p_message: "Tell us about your stay, special requests...",
    book_submit: "Send Booking Request",
    book_submitting: "Sending...",
    book_err_required: "Please fill in your name, email and phone.",
    book_err_dates: "Please choose check-in and check-out dates.",
    book_err_range: "Check-out must be after check-in.",
    book_err_generic: "Something went wrong. Please try again.",
    book_success: "Thank you! Your booking request has been received.",

    // Footer
    foot_tagline:
      "A peaceful Cretan escape — bright apartments, blooming gardens, and the sea just 900 m away.",
    foot_quick: "Quick Links",
    foot_facilities: "Facilities",
    foot_contact: "Contact",
    foot_fac_pool: "Outdoor pool",
    foot_fac_wifi: "Free WiFi",
    foot_fac_parking: "Free parking",
    foot_fac_bbq: "BBQ & garden",
    foot_fac_kids: "Children's playground",
    foot_copyright: "Athina Villas · Istron, Kalo Chorio 72100, Crete · License 1071629",
    foot_crafted: "Crafted with care · Crete, GR",
  },
  el: {
    // Nav
    nav_home: "Αρχική",
    nav_apartments: "Διαμερίσματα",
    nav_facilities: "Παροχές",
    nav_location: "Τοποθεσία",
    nav_gallery: "Φωτογραφίες",
    nav_contact: "Επικοινωνία",
    nav_book_now: "Κάντε κράτηση",
    brand_villas: "Βίλλες",

    // Hero
    hero_eyebrow: "Ήρεμες διακοπές στην Κρήτη",
    hero_h1_a: "Φιλόξενα",
    hero_h1_b: "διαμερίσματα",
    hero_h1_c: "στο",
    hero_h1_d: "Ίστρον, Κρήτη",
    hero_sub:
      "Φωτεινά, ευάερα διαμερίσματα με θέα στη θάλασσα, τον κήπο και τα βουνά — μόλις 900 μέτρα από την παραλία Καραβοστάσι.",
    hero_cta_book: "Κάντε κράτηση",
    hero_cta_explore: "Δείτε τα διαμερίσματα",
    hero_loc: "Ίστρον · Κρήτη",
    hero_h1_900m: "900 μ. από την παραλία Καραβοστάσι",
    hero_h1_pool: "Εξωτερική πισίνα",
    hero_h1_wifi: "Δωρεάν WiFi & πάρκινγκ",
    hero_h1_agios: "10 χλμ. από τον Άγιο Νικόλαο",

    // About
    about_eyebrow: "— Για το κατάλυμα",
    about_title_a: "Καλώς ήρθατε στις",
    about_title_b: "Αθηνά",
    about_title_c: "Βίλλες",
    about_text:
      "Στις Βίλλες Αθηνά θα βρείτε ζεστά, οικογενειακά διαμερίσματα στο Ίστρον Αγίου Νικολάου, μέσα σε έναν καταπράσινο κήπο με θέα στη θάλασσα και τα βουνά. Διαθέτουμε τρεις τύπους διαμερισμάτων — με ένα ή δύο υπνοδωμάτια, με δυνατότητα θέας θαλάσσης — ιδανικά για ζευγάρια, οικογένειες και επισκέπτες που αναζητούν χαλάρωση κοντά στη θάλασσα. Τα κατοικίδια είναι ευπρόσδεκτα.",
    about_stat1: "Από ζευγάρια",
    about_stat2: "από Καραβοστάσι",
    about_stat3: "από Άγιο Νικόλαο",

    // Apartments
    apts_eyebrow: "— Τα διαμερίσματα",
    apts_title_a: "Τρεις τύποι.",
    apts_title_b: "Ένας",
    apts_title_c: "ηλιόλουστος",
    apts_title_d: "κήπος.",
    apts_intro:
      "Όλα τα διαμερίσματα είναι φωτεινά, ευάερα και πλήρως εξοπλισμένα. Διαλέξτε αυτό που σας ταιριάζει και απολαύστε ξέγνοιαστες ημέρες στην Κρήτη.",
    apts_most_popular: "Πιο δημοφιλές",
    apts_guests_3: "Έως 3 άτομα",
    apts_guests_5: "Έως 5 άτομα",
    apts_type_1: "Διαμέρισμα με ένα υπνοδωμάτιο",
    apts_type_2: "Διαμέρισμα με δύο υπνοδωμάτια",
    apts_type_3: "Διαμέρισμα δύο υπνοδωματίων · με θέα θάλασσα",
    apts_bed_full: "1 διπλό κρεβάτι",
    apts_bed_twin: "μονά κρεβάτια",
    apts_bed_sofa: "1 καναπές-κρεβάτι",
    apts_bed_bedroom: "υπνοδωμάτιο",
    apts_bed_bedroom_1: "υπνοδωμάτιο 1",
    apts_bed_bedroom_2: "υπνοδωμάτιο 2",
    apts_bed_living: "σαλόνι",
    apts_view_garden: "Θέα στον κήπο & τα βουνά",
    apts_view_sea: "Θέα στο Κρητικό Πέλαγος",
    apts_view_label: "Θέα",
    apts_price_label: "Τιμή",
    apts_per_night: "τη βραδιά",
    apts_cta: "Ζητήστε διαθεσιμότητα",
    apts_pricing_note:
      "Ενδεικτικές τιμές. Δεν περιλαμβάνεται το τέλος διαμονής 2€/βραδιά. Η τελική τιμή επιβεβαιώνεται κατόπιν επικοινωνίας.",
    apts_includes: "— Όλα τα διαμερίσματα περιλαμβάνουν",
    apts_floor_ground: "Ισόγειο",
    apts_inc_ac: "Κλιματισμό",
    apts_inc_kitchen: "Πλήρως εξοπλισμένη κουζίνα",
    apts_inc_bath: "Ιδιωτικό μπάνιο",
    apts_inc_balcony: "Ιδιωτικό μπαλκόνι",
    apts_inc_sofa: "Καναπέ-κρεβάτι",
    apts_inc_tv: "Τηλεόραση",
    apts_inc_entrance: "Ιδιωτική είσοδο",
    apts_inc_pool: "Πρόσβαση στην πισίνα",

    // Facilities
    fac_eyebrow: "— Οι πιο αγαπημένες παροχές",
    fac_title_a: "Όλα όσα χρειάζεστε για",
    fac_title_b: "αληθινή",
    fac_title_c: "χαλάρωση.",
    fac_pool: "Εξωτερική πισίνα",
    fac_sun: "Δωρεάν ξαπλώστρες",
    fac_garden: "Κήπος",
    fac_bbq: "Ψησταριά",
    fac_kids: "Παιδική χαρά",
    fac_seating: "Καθιστικό στον κήπο",
    fac_picnic: "Χώρος για πικ-νικ",
    fac_wifi: "Δωρεάν WiFi",
    fac_parking: "Δωρεάν πάρκινγκ",
    fac_nonsmoking: "Δωμάτια μη καπνιζόντων",

    // Location
    loc_eyebrow: "— Η τοποθεσία",
    loc_title_a: "Ίστρον &",
    loc_title_b: "Άγιος Νικόλαος",
    loc_intro:
      "Σε ένα ήσυχο σημείο του Ίστρου, σε μικρή απόσταση από παραλίες, ταβέρνες, καφέ, καταστήματα και τη γραφική παραθαλάσσια πόλη του Αγίου Νικολάου.",
    loc_map_label: "Από ψηλά · Ίστρον, Κρήτη",
    loc_map_caption: "Παράκτια Κρήτη · GR",
    loc_address: "Αθηνά Βίλας Ιστρο, Καλό Χωριό 721 00, Κρήτη",
    loc_d_karavostasi: "Παραλία Καραβοστάσι",
    loc_d_taverns: "Ταβέρνες, καφέ & καταστήματα",
    loc_d_kalou: "Παραλία Καλού Χωριού",
    loc_d_voulisma: "Παραλία Βούλισμα",
    loc_d_ammoudara: "Παραλία Αμμουδάρα",
    loc_d_agios: "Άγιος Νικόλαος",
    loc_d_lake: "Λίμνη Βουλισμένης",
    loc_d_panagia: "Παναγία η Βρεφοτρόφος",
    loc_d_airport: "Αεροδρόμιο Σητείας",
    loc_v_900m: "900 μέτρα",
    loc_v_10min: "10' με τα πόδια",
    loc_v_15min: "15' με τα πόδια",
    loc_v_4min: "4' με αυτοκίνητο",
    loc_v_8km: "8 χλμ.",
    loc_v_10km: "10 χλμ.",
    loc_v_55km: "55 χλμ.",

    // Gallery
    gal_eyebrow: "— Φωτογραφίες",
    gal_title_a: "Στιγμές από τις",
    gal_title_b: "Αθηνά",
    gal_intro:
      "Μια ματιά στην πισίνα, τον κήπο, τα διαμερίσματα και την παραλία λίγο πιο κάτω.",
    gal_pool: "Πισίνα",
    gal_pool_c: "Καλοκαιρινές ώρες στην πισίνα",
    gal_apt: "Διαμέρισμα",
    gal_apt_c: "Φωτεινός χώρος καθιστικού",
    gal_balcony: "Μπαλκόνι",
    gal_balcony_c: "Πέτρινη βεράντα με θέα στο βουνό",
    gal_garden: "Κήπος",
    gal_garden_c: "Βίλλες Αθηνά · μέσα στο πράσινο",
    gal_interior: "Εσωτερικό",
    gal_interior_c: "Σαλόνι με καμάρες",
    gal_twin: "Δίκλινο",
    gal_twin_c: "Άνετα υπνοδωμάτια",
    gal_twin_door_c: "Με δική του βεράντα",
    gal_coast: "Ακτογραμμή",
    gal_coast_c: "Ελαιώνες που συναντούν τη θάλασσα",

    // Reviews
    rev_eyebrow: "— Κριτικές επισκεπτών",
    rev_wonderful: "Υπέροχα",
    rev_from: "Από",
    rev_verified: "επιβεβαιωμένες κριτικές στο Booking.com",
    rev_cat_clean: "Καθαριότητα",
    rev_cat_value: "Τιμή / ποιότητα",
    rev_cat_host: "Φιλοξενία",
    rev_cat_loc: "Τοποθεσία",

    // Booking
    book_eyebrow: "— Κάντε την κράτησή σας",
    book_title_a: "Προγραμματίστε τη διαμονή σας στις",
    book_title_b: "Βίλλες Αθηνά",
    book_intro:
      "Στείλτε μας το αίτημά σας και θα επικοινωνήσουμε σύντομα με διαθεσιμότητα, τιμές και χρήσιμες συμβουλές για τις διακοπές σας στην Κρήτη.",
    book_checkin: "Άφιξη",
    book_checkout: "Αναχώρηση",
    book_phone_lbl: "Τηλέφωνο",
    book_email_lbl: "Email",
    book_address_lbl: "Διεύθυνση",
    book_f_name: "Ονοματεπώνυμο",
    book_f_email: "Email",
    book_f_phone: "Τηλέφωνο",
    book_f_guests: "Άτομα",
    book_f_message: "Μήνυμα",
    book_p_name: "Π.χ. Γιώργος Παπαδόπουλος",
    book_p_email: "name@example.com",
    book_p_phone: "+30 ...",
    book_p_checkin: "Επιλέξτε ημερομηνία άφιξης",
    book_p_checkout: "Επιλέξτε ημερομηνία αναχώρησης",
    book_p_message:
      "Πείτε μας λίγα λόγια για τη διαμονή σας ή τυχόν ειδικές ανάγκες...",
    book_submit: "Αποστολή αιτήματος",
    book_submitting: "Αποστολή...",
    book_err_required:
      "Συμπληρώστε ονοματεπώνυμο, email και τηλέφωνο.",
    book_err_dates: "Επιλέξτε ημερομηνίες άφιξης και αναχώρησης.",
    book_err_range:
      "Η αναχώρηση πρέπει να είναι μετά την άφιξη.",
    book_err_generic: "Κάτι δεν πήγε καλά. Δοκιμάστε ξανά σε λίγο.",
    book_success:
      "Ευχαριστούμε! Το αίτημά σας ελήφθη — θα σας απαντήσουμε σύντομα.",

    // Footer
    foot_tagline:
      "Μια ήσυχη γωνιά της Κρήτης — φωτεινά διαμερίσματα, ανθισμένος κήπος και η θάλασσα μόλις 900 μέτρα μακριά.",
    foot_quick: "Σύνδεσμοι",
    foot_facilities: "Παροχές",
    foot_contact: "Επικοινωνία",
    foot_fac_pool: "Εξωτερική πισίνα",
    foot_fac_wifi: "Δωρεάν WiFi",
    foot_fac_parking: "Δωρεάν πάρκινγκ",
    foot_fac_bbq: "Ψησταριά & κήπος",
    foot_fac_kids: "Παιδική χαρά",
    foot_copyright:
      "Βίλλες Αθηνά · Ίστρον, Καλό Χωριό 72100, Κρήτη · ΜΗΤΕ 1071629",
    foot_crafted: "Φιλοξενία από καρδιάς · Κρήτη, GR",
  },
};
